import React, { useId, useRef } from 'react';
import { Alert, Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { CloudUploadOutlined, DeleteOutline } from '@mui/icons-material';
import { MAX_EXPENSE_RECEIPTS_PER_UPLOAD, mergeExpenseReceiptFiles } from '../utils/expenseReceiptUploads';

export default function ExpenseReceiptPicker({ files, onChange, error = '', onError }) {
  const input = useRef(null);
  const id = useId();
  const helpId = `${id}-help`;
  const errorId = `${id}-error`;
  const describedBy = `${helpId}${error ? ` ${errorId}` : ''}`;
  const select = (event) => {
    const selected = Array.from(event.target.files || []);
    event.target.value = '';
    if (!selected.length) return;
    const result = mergeExpenseReceiptFiles(files, selected);
    onChange(result.files);
    onError(result.error);
  };

  return <Stack spacing={1.25} sx={{ minWidth: 0 }}>
    <Box sx={{ border: '2px dashed', borderColor: error ? 'error.main' : 'divider', borderRadius: 2, p: 2, minWidth: 0 }}>
      <input ref={input} type="file" hidden multiple accept="image/*,application/pdf" aria-label="Comprobantes del gasto" aria-describedby={describedBy} aria-invalid={Boolean(error)} onChange={select} />
      <Button fullWidth variant="outlined" startIcon={<CloudUploadOutlined />} onClick={() => input.current?.click()} aria-describedby={describedBy} aria-invalid={Boolean(error)} sx={{ minHeight: 48, mb: 1 }}>Adjuntar PDF o imágenes</Button>
      <Typography variant="body2" role="status" aria-live="polite" sx={{ overflowWrap: 'anywhere' }}>{files.length} / {MAX_EXPENSE_RECEIPTS_PER_UPLOAD} archivos seleccionados</Typography>
      <Typography id={helpId} variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>Hasta {MAX_EXPENSE_RECEIPTS_PER_UPLOAD} archivos nuevos por envío. Los adjuntos ya guardados no cuentan.</Typography>
    </Box>
    {error && <Alert id={errorId} severity="error" sx={{ overflowWrap: 'anywhere' }}>{error}</Alert>}
    {files.length > 0 && <Stack component="ul" spacing={0.5} aria-label="Archivos nuevos seleccionados" sx={{ listStyle: 'none', p: 0, m: 0, maxHeight: 240, overflowY: 'auto', minWidth: 0 }}>
      {files.map((file, index) => <Stack component="li" key={`${file.name}:${file.size}:${file.lastModified}`} direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
        <Typography variant="body2" sx={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>{file.name}</Typography>
        <IconButton aria-label={`Quitar ${file.name}`} onClick={() => { onChange(files.filter((_, item) => item !== index)); onError(''); }} sx={{ width: 44, height: 44, flexShrink: 0 }}><DeleteOutline /></IconButton>
      </Stack>)}
    </Stack>}
  </Stack>;
}
